import { defaultNS as e } from "./i18n-config.mjs";
import { createContext as t, useCallback as n, useEffect as r, useState as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/translations/create-locale-provider.tsx
var o = () => {
	let o = t(null);
	return {
		LocaleContext: o,
		LocaleProvider: ({ i18n: t, languageCode: s, loadLangBundle: c, onChange: l, children: u }) => {
			let [d, f] = i(t.language), p = n((n) => {
				t.hasResourceBundle(n, "common") ? (t.changeLanguage(n), f(n), l?.(n)) : c?.(n, e).then((r) => {
					t.addResourceBundle(n, e, { ...r }), t.changeLanguage(n), f(n), l?.(n);
				}).catch((e) => {
					console.error("Error loading lang bundle", n, e);
				});
			}, [
				t,
				c,
				l
			]);
			return r(() => {
				t.isInitialized && t.language !== s && p(s);
			}, [
				s,
				p,
				t.isInitialized,
				t.language
			]), /* @__PURE__ */ a(o.Provider, {
				value: {
					i18n: t,
					currentLanguageCode: d,
					changeLocale: p
				},
				children: u
			});
		}
	};
};
//#endregion
export { o as createLocaleProvider };
